import { convertCompanyStatus } from "@/frontend/shared/lib/convertCompanyStatus/convertCompanyStatus";
import { getStateAbbreviation } from "@/frontend/shared/lib/getStateAbbreviation/getStateAbbreviation";
import { Typography } from "@/frontend/shared/ui/Typography";
import { SectionContentWrapper } from "@/frontend/widgets/SectionContentWrapper/SectionContentWrapper";
import styles from "./OverviewByInnovera.module.scss";
import { bigNumberConverter } from "@/frontend/shared/lib/bigNumberConverter/bigNumberConverter";
import { InnoveraBlockNoData } from "@/frontend/features/Company/ui/InnoveraBlockNoData/InnoveraBlockNoData";
import { SectionLoader } from "../../Section/SectionLoader/SectionLoader";
import { TCompanyProfile } from "@/libs/models/companies";
import { TInnoveraCompany } from "@/libs/models/portfolio-companies";
export type OverviewByInnoveraProps = {
  innoveraData?: TCompanyProfile | TInnoveraCompany;
  onReportError?: () => void;
  isLoadingInnoveraData: boolean;
};

export function OverviewByInnovera({
  innoveraData,
  onReportError,
  isLoadingInnoveraData: isLoading
}: OverviewByInnoveraProps) {
  const content = () => {
    if (isLoading) return <SectionLoader />;

    if (!!innoveraData) {
      const { description, totalFunding, city, country, foundingDate, state } = innoveraData;
      return (
        <div className={styles.innoveraBlock}>
          {!!description && (
            <div className={styles.bottomLineDivider}>
              <Typography variant="body-2" color="greyscale900">
                {description}
              </Typography>
            </div>
          )}
          <div className={styles.innoveraBlockTitle} role="heading" aria-level={7}>
            <Typography variant="heading-7" color="greyscale900">
              Highlights
            </Typography>
          </div>
          <div className={styles.bottomInnoveraBlockContent}>
            <div className={styles.contentSubContainer}>
              <Typography variant="label-4" color="greyscale600">
                Founded
              </Typography>
              <Typography variant="label-3" color="greyscale900">
                {foundingDate?.getFullYear() || "-"}
              </Typography>
            </div>
            <div className={styles.contentSubContainer}>
              <Typography variant="label-4" color="greyscale600">
                Total funding
              </Typography>
              <Typography variant="label-3" color="greyscale900">
                {totalFunding ? `$${bigNumberConverter(totalFunding)}` : "-"}
              </Typography>
            </div>
            <div className={styles.contentSubContainer}>
              <Typography variant="label-4" color="greyscale600">
                Status
              </Typography>
              <Typography variant="label-3" color="greyscale900">
                {(innoveraData.financialStage && convertCompanyStatus(innoveraData?.financialStage)) || "-"}
              </Typography>
            </div>
            <div className={styles.contentSubContainer}>
              <Typography variant="label-4" color="greyscale600">
                HQ Location
              </Typography>
              <Typography variant="label-3" color="greyscale900">
                {city ? city : "-"}
                {state ? `${getStateAbbreviation(state)}` : ""}
                {country ? `, ${country}` : ""}
              </Typography>
            </div>
          </div>
        </div>
      );
    }
    return <InnoveraBlockNoData />;
  };

  return (
    <SectionContentWrapper isByInnovera companyName="Crunchbase" onReportError={onReportError}>
      {content()}
    </SectionContentWrapper>
  );
}
